import VariationSetsService from '~/services/VariationSetsService';

export const download = (jobId: number, jobVariationId?: number) => {
    VariationSetsService.generateSignedUrlForVariationDownload(jobId, jobVariationId).then((signedUrl) => {
        if (!signedUrl) {
            return;
        }

        const a = document.createElement('a');
        a.setAttribute('href', signedUrl);
        a.setAttribute('target', '_blank');
        a.setAttribute('download', '');
        a.click();
    });
};

export const downloadPdf = (jobId: number) => {
    VariationSetsService.generateSignedUrlForVariationDownload(jobId).then((signedUrl) => {
        if (!signedUrl) {
            return;
        }

        if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            const a = document.createElement('a');
            a.setAttribute('href', signedUrl);
            a.setAttribute('target', '_blank');
            a.setAttribute('download', '');
            a.click();
            return;
        } else {
            const { origin } = window.location;
            window.location.href = `${origin}${signedUrl}`;
        }
    });
};
